(function () {
  'use strict';
  window.snrUpsellAdd = function (btn, variantId) {
    if (btn.classList.contains('loading') || btn.classList.contains('done')) return;
    btn.classList.add('loading');
    var orig = btn.textContent;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) { btn.classList.remove('loading'); btn.textContent = orig; return; }
      btn.classList.remove('loading');
      btn.classList.add('done');
      btn.textContent = '✓ Toegevoegd';
      if (window.SHTHelper && typeof SHTHelper.forceUpdateCartStatus === 'function') {
        SHTHelper.forceUpdateCartStatus({ id: parseInt(variantId, 10) });
      }
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        document.querySelectorAll('.js-cart-count,.header__cart-count').forEach(function(el){ el.textContent = cart.item_count; });
      });
    })
    .catch(function () { btn.classList.remove('loading'); btn.textContent = orig; });
  };

  /* Kortingscode via de Cart API: geen redirect meer via /discount/, dus geen Shopify-foutpagina.
     Niet-geldige codes geven een melding in de cart in plaats van een stille refresh. */
  function snrDiscountMessage(text, isError) {
    var bar = document.querySelector('.snr-discount-bar');
    if (!bar) return;
    var msg = document.getElementById('snrDiscountMsg');
    if (!msg) {
      msg = document.createElement('div');
      msg.id = 'snrDiscountMsg';
      msg.style.cssText = 'width:100%;font-size:13px;line-height:18px;margin-top:6px;';
      bar.parentNode.insertBefore(msg, bar.nextSibling);
    }
    msg.style.color = isError ? '#b3261e' : '#1f6f43';
    msg.textContent = text;
  }

  function snrSafeReloadUrl() {
    var path = window.location.pathname;
    if (path.indexOf('/cart/') === 0 || path.indexOf('/discount/') === 0) return '/cart';
    return path + window.location.search;
  }

  window.snrApplyDiscount = function () {
    var input = document.getElementById('snrDiscountInput');
    var btn = document.getElementById('snrDiscountApplyBtn');
    if (!input) return;
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    var origLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: code })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var codes = (cart && cart.discount_codes) || [];
      var match = null;
      for (var i = 0; i < codes.length; i++) {
        if (String(codes[i].code).toUpperCase() === code.toUpperCase()) { match = codes[i]; break; }
      }
      if (match && match.applicable) {
        try { sessionStorage.setItem('snrReopenCartDrawer', '1'); } catch (e) {}
        window.location.href = snrSafeReloadUrl();
        return;
      }
      if (btn) { btn.disabled = false; btn.textContent = origLabel; }
      snrDiscountMessage('Code "' + code + '" is niet geldig voor je winkelwagen. Check de voorwaarden van de actie (zoals een minimumbedrag).', true);
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = origLabel; }
      snrDiscountMessage('Er ging iets mis. Probeer het opnieuw of voer de code in bij het afrekenen.', true);
    });
  };

  function snrMaybeReopenCartDrawer() {
    var shouldReopen = false;
    try { shouldReopen = sessionStorage.getItem('snrReopenCartDrawer') === '1'; } catch (e) {}
    if (!shouldReopen) return;
    try { sessionStorage.removeItem('snrReopenCartDrawer'); } catch (e) {}
    setTimeout(function () {
      if (window.shtCartDrawer && typeof window.shtCartDrawer.openDrawer === 'function') {
        window.shtCartDrawer.openDrawer();
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', snrMaybeReopenCartDrawer);
  } else {
    snrMaybeReopenCartDrawer();
  }
})();
